import {
  ComponentTypeInventoryDatasourceSelection,
  DatasetInventoryDatasourceSelection,
  InventoryDatasourceSelection,
  MyApplicationTypeInventoryDatasourceSelection,
  ReportInventoryDatasourceSelection,
  WorkspaceInventoryDatasourceSelection,
} from './types';

const getWorkspaceIdsFromDatasource = (
  datasource: InventoryDatasourceSelection
) => {
  switch (datasource.dataSourceType) {
    case 'workspace':
      return datasource.selectedWorkspaceIds;
    case 'report':
      return datasource.report.workspaceIds ?? [];
    case 'componentType':
      return datasource.workspaceIds;
    case 'myApplicationType':
      return [];
    case 'dataset':
      return []; // TODO AM looks like we will need a refactor and checking scope data or changes to creating components
    default:
      datasource satisfies never;
      return [];
  }
};

const isWorkspaceInventoryDatasourceSelection = (
  datasourceSelection: InventoryDatasourceSelection
): datasourceSelection is WorkspaceInventoryDatasourceSelection =>
  datasourceSelection.dataSourceType === 'workspace';

const isReportInventoryDatasourceSelection = (
  datasourceSelection: InventoryDatasourceSelection
): datasourceSelection is ReportInventoryDatasourceSelection =>
  datasourceSelection.dataSourceType === 'report';

const isDatasetInventoryDatasourceSelection = (
  datasourceSelection: InventoryDatasourceSelection
): datasourceSelection is DatasetInventoryDatasourceSelection =>
  datasourceSelection.dataSourceType === 'dataset';

const isComponentTypeInventoryDatasourceSelection = (
  datasourceSelection: InventoryDatasourceSelection
): datasourceSelection is ComponentTypeInventoryDatasourceSelection =>
  datasourceSelection.dataSourceType === 'componentType';

const isMyApplicationTypeInventoryDatasourceSelection = (
  datasourceSelection: InventoryDatasourceSelection
): datasourceSelection is MyApplicationTypeInventoryDatasourceSelection =>
  datasourceSelection.dataSourceType === 'myApplicationType';

const isWorkspaceOrComponentTypeInventoryDatasourceSelection = (
  datasourceSelection: InventoryDatasourceSelection
): datasourceSelection is
  | ComponentTypeInventoryDatasourceSelection
  | WorkspaceInventoryDatasourceSelection =>
  isComponentTypeInventoryDatasourceSelection(datasourceSelection) ||
  isWorkspaceInventoryDatasourceSelection(datasourceSelection);

/**
 * Used for tracking.
 */
const getDatasourceSelectionCount = (
  datasourceSelection: InventoryDatasourceSelection
): number => {
  switch (datasourceSelection.dataSourceType) {
    case 'componentType':
      return datasourceSelection.componentTypeNames.length;
    case 'workspace':
      return datasourceSelection.selectedWorkspaceIds.length;
    case 'report':
      return 1; // there's always just one report at a time
    case 'myApplicationType':
      return 1;
    case 'dataset':
      return datasourceSelection.loadedStateParams.length;
    default:
      datasourceSelection satisfies never;
      return 0;
  }
};

// A new key will force the AG Grid to remount (re-firing onGridReady) when the datasource changes
const getInventoryGridKey = (
  datasource: InventoryDatasourceSelection
): string =>
  `${datasource.dataSourceType}:${[...getWorkspaceIdsFromDatasource(datasource)].sort().join(',')}`;

export const inventoryDatasourceOperations = {
  getWorkspaceIdsFromDatasource,
  getInventoryGridKey,
  isWorkspaceInventoryDatasourceSelection,
  isReportInventoryDatasourceSelection,
  isComponentTypeInventoryDatasourceSelection,
  isMyApplicationTypeInventoryDatasourceSelection,
  isDatasetInventoryDatasourceSelection,
  isWorkspaceOrComponentTypeInventoryDatasourceSelection,
  getDatasourceSelectionCount,
};
